<div class="mainContent" style="height: 95vh;">
  <header style="height: 7vh; padding-left: 2%;">
    <label i18n="@@spmsUserReg" class="textColour">Import Dataset</label>
  </header>

  <main style="flex: 1; overflow: hidden; padding: 2%;">
    <form #importForm="ngForm" novalidate (ngSubmit)="importData()" style="width: 100%;">

      <div class="row" style="margin-top: 10px;">
        <div class="col-lg-12">
          <label style="cursor: default; font-weight: bold;">Select Object Groups</label>
          <mat-form-field appearance="outline" style="width: 100%;" required>
            <mat-label>Select Object Groups</mat-label>
            <mat-select [(ngModel)]="selectedObjectGroup" name="objectGroup" required>
              <mat-option *ngFor="let objectGroup of objectGroupNames" [value]="objectGroup.objectGroupId">
                {{ objectGroup.objectGroupName }} (ID: {{ objectGroup.objectGroupId }})
              </mat-option>
            </mat-select>
            <mat-error *ngIf="importForm.controls.objectGroup?.invalid && importForm.controls.objectGroup?.touched" style="color: red; margin-top: 4px;">
              You must select an object group.
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      
      <div class="row" style="margin-top: 20px;">
        <div class="col-lg-8">
          <label style="cursor: default;">Choose Folder</label>
          <input 
            type="file" 
            id="file-upload" 
            (change)="onFileChange($event)" 
            aria-label="File upload" 
            webkitdirectory 
            multiple
            required
            style="display: none;" 
            #fileInput
          >
          <button type="button" (click)="fileInput.click()"
                  class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" 
                  [style.background-color]="buttonColor" 
                  style="padding: .3rem 1.6rem; font-size: .85rem; width: 120px; color: white;">
            Browse...
          </button>
      
          <div *ngIf="!validFolder && fileInput.files.length === 0" style="color: red; margin-top: 4px;">
            The selected folder must contain at least one file.
          </div>

          <div *ngIf="uploadedFolderName" style="margin-top: 4px; color: green;">
            Selected Folder: {{ uploadedFolderName }}
          </div>
        </div>
      </div>

      <div style="position: sticky; left: 0; bottom: 0; width: 100%; background: white; z-index: 1;">
        <div class="row text-center">
          <div class="col-lg">
            <div style="text-align: end;">
              <button type="submit" [disabled]="importForm.invalid"
                      class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" 
                      [style.background-color]="buttonColor" 
                      style="padding: .3rem 1.6rem; font-size: .85rem; width: 95px; color: white;">
                Import
              </button>

              <button type="button" (click)="close()"
                      class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" 
                      [style.background-color]="buttonColor" 
                      style="padding: .3rem 1.6rem; font-size: .85rem; width: 95px;">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div style="margin-top: 10px; overflow: auto;">
      <div style="width: 100%;">
        <mat-toolbar class="agGridtopersDiv card" style="background: rgba(228, 227, 230, 0.41); border: 1px solid #a9a9a9;">
          <label i18n="@@spmsUserReg" class="gridLabel">Import History</label>
          <span class="example-spacer"></span>

          <button type="button" (click)="refreshRun()"
          class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" 
          [style.background-color]="buttonColor" 
          style="padding: .3rem 1.6rem; font-size: .85rem; width: 120px; color: white;">
            Refresh
          </button>
          <div class="selectRecordsDiv" style="width: 9.5%;">
            <mat-form-field appearance="outline" style="width: 100%;">
              <mat-label i18n="@@Targetrecords" style="color: black">Records</mat-label>
              <mat-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChanged($event)">
                <mat-option value="10" selected>10</mat-option>
                <mat-option value="200">200</mat-option>
                <mat-option value="300">300</mat-option>
                <mat-option value="400">400</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
      
          <div class="card pagination paginationFirstButton paginationFirstlastButton">
            <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
          </div>
          <div class="card pagination paginationButtons btn-rounded">
            <ul>
              <li class="paginationliicon">
                <em class="fas fa-angle-left waves-effect waves-light" (click)="onBtPrevious()"></em>
              </li>
              <li>{{ currentpage }}/{{ totalpages }}</li>
              <li class="paginationliicon" style="padding: 0">
                <em class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em>
              </li>
            </ul>
          </div>
          <div class="card pagination paginationLastButton paginationFirstlastButton">
            <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
          </div>
        </mat-toolbar>
      </div>

      <!-- Dispatch ag-grid -->
      <ag-grid-angular class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
        [columnDefs]="columnDefs"  
        [animateRows]="true"
        [pagination]="true" 
        [defaultColDef]="defaultColDef" 
        [suppressPaginationPanel]="true" 
        [rowHeight]="35"
        [headerHeight]="35" 
        [enableBrowserTooltips]="true" 
        [floatingFiltersHeight]="45"
        [paginationPageSize]="paginationPageSize" 
        [paginationNumberFormatter]="paginationNumberFormatter"
        [enableRangeSelection]="true" 
        [debug]="true" 
        (paginationChanged)="onPaginationChanged()" 
        [components]="components"
        (gridReady)="onGridReady($event)" 
        [hidden]="!true">
      </ag-grid-angular>
    </div>

  </main>
</div>
